import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { apiFetch, clearAuthSession, getAuthUser } from "./api";
import ClientDashboard from "./ClientDashboard";
import ClientDetail from "./ClientDetail";
import ClientProjectDetail from "./ClientProjectDetail";
import ClientProjects from "./ClientProjects";
import ClientSaleDetail from "./ClientSaleDetail";
import ClientSales from "./ClientSales";
import Login from "./Login";
import SiteDashboard from "./SiteDashboard";
import SiteDetail from "./SiteDetail";

function App() {
  const [user, setUser] = useState(getAuthUser());

  useEffect(() => {
    document.body.classList.add("render-inspired");
    return () => document.body.classList.remove("render-inspired");
  }, []);

  useEffect(() => {
    if (!user) return;

    apiFetch("/api/auth/me")
      .then(res => {
        if (!res.ok) {
          clearAuthSession();
          setUser(null);
        }
      });
  }, [user]);

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  return (
    <BrowserRouter>
      <div style={{ padding: "10px 20px", borderBottom: "1px solid #ddd" }}>
        <span>{user.email}</span>
        <button
          style={{ marginLeft: "10px" }}
          onClick={() => (window.location.href = "/")}
        >
          Clients
        </button>
        <button
          style={{ marginLeft: "10px" }}
          onClick={() => (window.location.href = "/atc")}
        >
          ATC Dashboard
        </button>
        <button
          style={{ marginLeft: "10px" }}
          onClick={() => {
            apiFetch("/api/auth/logout", { method: "POST" }).finally(() => {
              clearAuthSession();
              setUser(null);
            });
          }}
        >
          Logout
        </button>
      </div>
      <Routes>
        <Route path="/" element={<ClientDashboard user={user} />} />
        <Route path="/clients/:id" element={<ClientDetail user={user} />} />
        <Route path="/clients/:id/sales" element={<ClientSales user={user} />} />
        <Route path="/clients/:id/sales/:saleId" element={<ClientSaleDetail user={user} />} />
        <Route path="/clients/:id/projects" element={<ClientProjects user={user} />} />
        <Route path="/clients/:id/projects/:projectId" element={<ClientProjectDetail user={user} />} />
        <Route path="/atc" element={<SiteDashboard user={user} />} />
        <Route path="/site/:id" element={<SiteDetail user={user} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
